import { useEffect, useState } from 'react';
import { post } from '../../services/api';
import { ToastContainer, toast } from 'react-toastify';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { TailSpin } from "react-loader-spinner";
import { ThreeDots } from "react-loader-spinner";

function CadastroClusterTrv() {

    const [clusters, setClusters] = useState(null);
    const [clusterSelecionado, setClusterSelecionado] = useState({});
    const [editarDescricao, setEditarDescricao] = useState('');
    const [salvarDescricao, setSalvarDescricao] = useState('');
    const [isFetchingSalvarCluster, setIsFetchingSalvarCluster] = useState(false);
    const [isFetchingCarregarCluster, setIsFetchingCarregarCluster] = useState(false);


    useEffect(() => {
        getClusters();
    }, []);

    const authToken = localStorage.getItem('adminToken');

    async function getClusters() {
        try {
            setIsFetchingCarregarCluster(true);

            const response = await post('/admin/trv/clusters', {}, authToken);

            setIsFetchingCarregarCluster(false);

            setClusters(response);
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function salvarCluster() {
        try {
            const requisicao = { descricao: salvarDescricao };

            setIsFetchingSalvarCluster(true);

            const response = await post('/admin/trv/salvarcluster', requisicao, authToken);

            setIsFetchingSalvarCluster(false);

            if (!response.Sucesso) {
                toast.error(response.Mensagem);
                return;
            }

            toast.success(response.Mensagem);
            setSalvarDescricao('');
            getClusters();
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    const confirmarExclusao = (idcluster) => {
        withReactContent(Swal).fire({
            title: <i>Deseja excluir?</i>,
            html: 'O cluster será deletado permanentemente!',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            confirmButtonColor: "red",
        }).then((result) => {
            if (result.isConfirmed) {
                deletarCluster(idcluster);
            }
        });
    };

    async function deletarCluster(idcluster) {
        try {
            const requisicao = { idcluster: idcluster };
            const response = await post('/admin/trv/deletarcluster', requisicao, authToken);

            if (!response.Sucesso) {
                toast.error(response.Mensagem);
                return;
            }

            toast.success(response.Mensagem);
            getClusters();
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    };

    const editarCluster = (cluster) => {
        setClusterSelecionado({ id: cluster.idcluster, descricao: cluster.descricao });
        setEditarDescricao(cluster.descricao);
    };

    const cancelarEdicaoCluster = () => {
        setClusterSelecionado({});
    };

    async function confirmarEdicaoCluster(id) {
        try {
            const requisicao = { idcluster: id, descricao: editarDescricao };

            setIsFetchingSalvarCluster(true);

            const response = await post('/admin/trv/alterarcluster', requisicao, authToken);

            setIsFetchingSalvarCluster(false);

            if (!response.Sucesso) {
                toast.error(response.Mensagem);
                return;
            }
            setClusterSelecionado({});
            toast.success(response.Mensagem);
            getClusters();
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    };

    return (
        <div className='form-gerencia-animal'>
            <div className="filtros-consulta-wrapper">
                <div className="header">
                    <span>1</span>
                    <h1>Selecione os filtros</h1>
                </div>
                <div className="body">
                    <div className='regiao-wrapper'>
                        <label htmlFor="regiao">Informe o cluster</label>
                        <input style={{ maxWidth: '190px' }} placeholder='Nome do Cluster' type="text" value={salvarDescricao} onChange={e => setSalvarDescricao(e.currentTarget.value)} required />
                    </div>
                    <button className="load-metas-btn" onClick={() => salvarCluster()}>
                        {isFetchingSalvarCluster ? (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <TailSpin color="#ffffff" height={20} width={39} />
                            </div>
                        )
                            :
                            (
                                "Salvar"
                            )}
                    </button>
                </div>
            </div>
            <div className='gerencia-animal-second'>
                <div className="header">
                    <div>
                        <span>2</span>
                        <h1>Clusters Cadastrados</h1>
                    </div>

                    
                    {isFetchingCarregarCluster && (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <ThreeDots
                                    height="5"
                                    width="80"
                                    radius="9"
                                    color="#ff0000"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{}}
                                    wrapperClassName=""
                                    visible={true}
                                />
                            </div>
                        )}
                </div>
                <div className="px-36">
                    <table className="adm-table metas-animais">
                        <thead>
                            <tr>
                                <th>Descrição</th>
                                <th className="acao-column">Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(clusters) && clusters.map(cluster => (
                                <tr key={cluster.idcluster} className={`adm-table-row row-metas-animais`}>
                                    <td>
                                        {clusterSelecionado.id === cluster.idcluster ? (
                                            <input type="text" value={editarDescricao} onChange={e => setEditarDescricao(e.target.value)} className="p-1 border rounded" />
                                        ) : (
                                            cluster.descricao
                                        )}
                                    </td>
                                    <td className="acao-column flex flex-col gap-4 items-center lg:flex-row lg:justify-center">
                                        {clusterSelecionado.id === cluster.idcluster ? (
                                            <>
                                                <button onClick={() => confirmarEdicaoCluster(cluster.idcluster)} className="p-2 mr-2 bg-green-500 text-white rounded shadow">
                                                    {isFetchingSalvarCluster ? (
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                            <TailSpin color="#ffffff" height={20} width={39} />
                                                        </div>
                                                    )
                                                    :
                                                    (
                                                        "Salvar"
                                                    )}
                                                </button>
                                                <button onClick={cancelarEdicaoCluster} className="p-2 bg-red-500 text-white rounded shadow">
                                                    Cancelar
                                                </button>
                                            </>
                                        ) : (
                                            <>
                                                <button onClick={() => editarCluster(cluster)} className="p-2 mr-2 bg-blue-500 text-white rounded shadow">
                                                    Alterar
                                                </button>
                                                <button onClick={() => confirmarExclusao(cluster.idcluster)} className="p-2 bg-red-500 text-white rounded shadow">
                                                    Deletar
                                                </button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};








export default CadastroClusterTrv